import axiosInstance from "../Interceptor";
import axios from "axios";

export const getFlagshipListApi = (data) => {
  // console.log(payload);

   const baseUrl = process.env.REACT_APP_BASE_URL_TWO;
  return axios
    .get(`${baseUrl}users/api/v1/flagship/${data}/`)
    .then((res) => {
   
      return res;
    })
    .catch((err) => {
   
      return err;
    });
};
